import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator',
	// Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
	path: '/issues/:issueKey?',
	query: ['selectedIssue?'],
};
